import { SetDepositBalance } from "../actions/deposit";
import { browserHistory } from "react-router";
import Config from "../config/main";
import { SetTerminalAuthData, SendLogs } from "../actions/terminal";
import { OpenPopup } from "../actions/ui";

const depositTerminalspecific = (store) => {
    const authData = sessionStorage.getItem('authData') && JSON.parse(sessionStorage.getItem('authData'));
    return new Promise(resolve => {
        window.addEventListener('contextmenu', (window) => {
            window.preventDefault();
        }, false);
        window.jsobject = window.jsobject || window.external || {};

        // ---------- functions that call C# ----------
        (() => {
            return Object.keys(Config.windowJSobjectFunctions).map(key => {
                if (!window.jsobject[key]) {
                    window.jsobject[key] = (data) => {
                        console.log(`${Config.windowJSobjectFunctions[key]} ${data ? "-----> " + data : ""}`);
                    };
                }
            });
        })();

        // ---------- function thst C# call in app ----------
        window.openAdminPage = () => {
            browserHistory.push('/admin');
            console.info("Open admin page");
        };
        window.setDepositAmount = (balance) => {
            store.dispatch(SetDepositBalance(balance));
        };
        window.sendStackerBalance = (text) => {
            store.dispatch(OpenPopup('showStackerBalance', {data: text}));
        };
        window.SetToken = (token) => {
            let params = {...authData};
            params.token = token;
            sessionStorage.setItem('authData', JSON.stringify(params));
            store.dispatch(SetTerminalAuthData({'authData': params}));
        };
        // ---------- Event listeners ----------
        window.addEventListener('keydown', (e) => {
            if (e.altKey && e.keyCode === 82) { // alt+r
                window.jsobject.reload();
            } else if (e.altKey && e.keyCode === 73) { //alt+i
                window.jsobject.inspectElement();
            } else if (e.altKey && e.keyCode === 65) { //alt+a
                window.openAdminPage();
                window.jsobject.adminPageWasOpened();
            } else if (e.altKey && e.keyCode === 76) { //alt+l
                window.jsobject.openLastLogFile();
            } else if (e.altKey && e.keyCode === 84) { //alt+t
                window.jsobject.openTerminalIdDialog();
            } else if (e.altKey && e.keyCode === 67) { //alt+c
                window.jsobject.openDmsLastTicketDialog();
            }
        });
        window.onerror = (msg, url, lineNo, columnNo, error) => {
            store.dispatch(SendLogs({msg, url, lineNo, columnNo, error: JSON.stringify(error)}));
        };
        resolve();
    });
};

export default depositTerminalspecific;
